// The question template types a read can ask. Mirrors the API's built-in
// template types; a vertical added there is added here.
export const TEMPLATE_TYPES = ['durable', '3p_durable', 'perishable', 'sports_betting'];
